import React from 'react'

import Router from './router'

import "./app.css"

const App = () => {
  return (
    <>
    <Router/>
    </>
  )
}

export default App